import React, { Component } from "react";

interface IGameAutoplayComponent {
    data: {}
}
export const gameAutoplayComponent: IGameAutoplayComponent = {
    data: {
        "COMPONENTS": [
            {
                child: [
                    {
                        "id": "gameAutoplayScrollComponent",
                        "name": "gameAutoplayScrollComponent",
                        "type": "Container",
                        "x": 0,
                        "y": 0,
                        "visible": true,
                        "filterTypes": [],
                        child: [

                        ]
                    },
                    {
                        "id": "gameAutoplayContent",
                        "name": "gameAutoplayContent",
                        "type": "Container",
                        "x": -550,
                        "y": -200,
                        "visible": true,
                        "filterTypes": [],
                        child: [


                            {
                                "id": "stopOnAnyWinContainer",
                                "name": "stopOnAnyWinContainer",
                                "type": "Container",
                                "x": 0,
                                "y": 0,
                                "visible": true,
                                child: [
                                    {
                                        "id": "stopOnAnyWin_text",
                                        "name": "stopOnAnyWin_text",
                                        "type": "Text",
                                        "x": 687,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "stopOnWinText",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },

                                    {
                                        "name": "stopOnAnyWin_enable",
                                        "image": "setting_radio_btn_enable.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 65,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                        "buttonMode": true,
                                        "buttonState": {
                                            up: 'setting_radio_btn_enable.png',
                                            out: 'setting_radio_btn_enable.png',
                                            down: 'setting_radio_btn_enable.png',
                                            disable: 'setting_radio_btn_enable.png',
                                            enable: 'setting_radio_btn_enable.png',
                                            hover: 'setting_radio_btn_enable.png'
                                        },
                                    },
                                    {
                                        "name": "stopOnAnyWin_disable",
                                        "image": "setting_radio_btn_disbale.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 65,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                        "buttonMode": true,
                                        "buttonState": {
                                            up: 'setting_radio_btn_disbale.png',
                                            out: 'setting_radio_btn_disbale.png',
                                            down: 'setting_radio_btn_disbale.png',
                                            disable: 'setting_radio_btn_disbale.png',
                                            enable: 'setting_radio_btn_disbale.png',
                                            hover: 'setting_radio_btn_disbale.png'
                                        },
                                    },

                                    {
                                        "name": "stopOnAnyWin_text_divider",
                                        "image": "text_divider.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 580,
                                        "height": 1,
                                        "anchor": [0.5, 0.5],
                                        "x": 970,
                                        "y": 370,
                                    },

                                ]
                            },
                            {
                                "id": "stopfeaturetriggeredContainer",
                                "name": "stopfeaturetriggeredContainer",
                                "type": "Container",
                                "x": 0,
                                "y": 150,
                                "visible": true,
                                child: [
                                    {
                                        "id": "stopfeaturetriggered_text",
                                        "name": "stopfeaturetriggered_text",
                                        "type": "Text",
                                        "x": 687,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "stopfeaturetriggeredText",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "name": "stopfeaturetriggered_enable",
                                        "image": "setting_radio_btn_enable.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 65,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                        "buttonMode": true,
                                        "buttonState": {
                                            up: 'setting_radio_btn_enable.png',
                                            out: 'setting_radio_btn_enable.png',
                                            down: 'setting_radio_btn_enable.png',
                                            disable: 'setting_radio_btn_enable.png',
                                            enable: 'setting_radio_btn_enable.png',
                                            hover: 'setting_radio_btn_enable.png'
                                        },
                                    },
                                    {
                                        "name": "stopfeaturetriggered_disable",
                                        "image": "setting_radio_btn_disbale.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 65,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                        "buttonMode": true,
                                        "buttonState": {
                                            up: 'setting_radio_btn_disbale.png',
                                            out: 'setting_radio_btn_disbale.png',
                                            down: 'setting_radio_btn_disbale.png',
                                            disable: 'setting_radio_btn_disbale.png',
                                            enable: 'setting_radio_btn_disbale.png',
                                            hover: 'setting_radio_btn_disbale.png'
                                        },
                                    },

                                    {
                                        "name": "stopfeaturetriggered_text_divider",
                                        "image": "text_divider.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 580,
                                        "height": 1,
                                        "anchor": [0.5, 0.5],
                                        "x": 970,
                                        "y": 370,
                                    },

                                ]
                            },
                            {
                                "id": "singlewinlimitContainer",
                                "name": "singlewinlimitContainer",
                                "type": "Container",
                                "x": 0,
                                "y": 300,
                                "visible": true,
                                child: [
                                    {
                                        "id": "singlewinlimit_text",
                                        "name": "singlewinlimit_text",
                                        "type": "Text",
                                        "x": 687,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "singleWinLimitText",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "name": "singlewinlimit_disable",
                                        "image": "num_shell.png",
                                        "type": "Image",
                                        "interactive": true,
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 126,
                                        "height": 32,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                    },
                                    {
                                        "name": "nummShellTxtField",
                                        "image": "num_shell.png",
                                        "type": "Image",
                                        "interactive": true,
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 126,
                                        "height": 32,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                    },

                                    {
                                        "name": "singlewinlimit_text_divider",
                                        "image": "text_divider.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",

                                        "visible": true,
                                        "width": 580,
                                        "height": 1,
                                        "anchor": [0.5, 0.5],
                                        "x": 970,
                                        "y": 370,
                                    },
                                    {
                                        "id": "singlewinlimit_Value",
                                        "name": "singlewinlimit_Value",
                                        "type": "Text",
                                        "x": 1208,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "0.00",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#000000'],
                                        },
                                    },
                                ]
                            },
                            {
                                "id": "winLimitContainer",
                                "name": "winLimitContainer",
                                "type": "Container",
                                "x": 0,
                                "y": 450,
                                "visible": true,
                                child: [
                                    {
                                        "id": "winLimit_text",
                                        "name": "winLimit_text",
                                        "type": "Text",
                                        "x": 687,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "winLimitText",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "name": "winLimit_disable",
                                        "image": "num_shell.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 126,
                                        "height": 32,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                    },

                                    {
                                        "name": "winLimit_text_divider",
                                        "image": "text_divider.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 580,
                                        "height": 1,
                                        "anchor": [0.5, 0.5],
                                        "x": 970,
                                        "y": 370,
                                    },
                                    {
                                        "id": "winlimit_Value",
                                        "name": "winlimit_Value",
                                        "type": "Text",
                                        "x": 1208,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "0.00",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#000000'],
                                        },
                                    },
                                ]
                            },
                            {
                                "id": "lossLimitContainer",
                                "name": "lossLimitContainer",
                                "type": "Container",
                                "x": 0,
                                "y": 600,
                                "visible": true,
                                child: [
                                    {
                                        "id": "lossLimit_text",
                                        "name": "lossLimit_text",
                                        "type": "Text",
                                        "x": 687,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "setting_loss-limit",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "name": "lossLimit_disable",
                                        "image": "num_shell.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 126,
                                        "height": 32,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                    },

                                    {
                                        "name": "lossLimit_text_divider",
                                        "image": "text_divider.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 580,
                                        "height": 1,
                                        "anchor": [0.5, 0.5],
                                        "x": 970,
                                        "y": 370,
                                    },
                                    {
                                        "id": "lossLimit_Value",
                                        "name": "lossLimit_Value",
                                        "type": "Text",
                                        "x": 1208,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "0.00",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#000000'],
                                        },
                                    },
                                ]
                            },
                        ]
                    },
                ]
            },

        ],
    }


};

export const GameAutoplayComponentConfigurationContext = React.createContext(
    {}
);